export default "data:application/javascript;base64,"